import Header from './component';

export default Header;